module.exports = __webpack_public_path__ + "img/instagram-b.6fee9beb.svg";